import React, { useEffect, useState } from 'react';
import logolight from "assets/images/mayaveLogo.svg";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import withRouter from 'Common/withRouter';
import { Card, Col, Button, Form, Alert, Spinner, Image, Row } from 'react-bootstrap';
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, resetLoginFlag } from "../../../slices/thunk";
import { createSelector } from 'reselect';
import Loader from 'Common/Loader';
import ParticlesAuth from './ParticlesAuth';
import { logoutUserSuccess } from 'slices/auth/login/reducer';

const Signin = (props: any) => {
    const navigate = useNavigate();
    const dispatch: any = useDispatch();
    const [loader, setLoader] = useState(false);
    const selectAccountAndLogin = createSelector(
        (state: any) => state.Account,
        (state: any) => state.Login,
        (account, login) => ({
            user: account?.user,
            error: login.error,
            loading: login.loading,
            errorMsg: login.errorMsg,
        })
    );

    const { user, error, loading, errorMsg } = useSelector(selectAccountAndLogin);

    const [userLogin, setUserLogin] = useState<any>([]);
    const [passwordShow, setPasswordShow] = useState<boolean>(false);

    useEffect(() => {
        if (user && user) {
            setUserLogin({
                userName: user.userName,
                password: user.password
            });
        }
    }, [user]);

    const validation: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            userName: userLogin.userName || "",
            password: userLogin.password || "",
        },
        validationSchema: Yup.object({
            userName: Yup.string().required("Please enter your user name"),
            password: Yup.string().required("Please enter your password"),
        }),

        onSubmit: (values) => {
            setLoader(true);
            const payload = {
                userName: values.userName,
                password: values.password,
            };
            dispatch(loginUser(payload, props.router.navigate))
                .then(() => {
                    setLoader(false);
                })
                .catch(() => {
                    setLoader(false);
                });
        }
    });

    useEffect(() => {
        if (errorMsg) {
            setTimeout(() => {
                dispatch(resetLoginFlag());
            }, 3000);
        }
    }, [dispatch, errorMsg]);

    useEffect(() => {
        localStorage.clear()
        dispatch(logoutUserSuccess({}));
    }, [])

    return (
        // <div className="auth-wrapper d-flex flex-wrap min-vh-100">
        //     {loader && <Loader />}

        //     <div className="d-none d-md-block col-md-6 p-0">
        //         <ParticlesAuth />
        //     </div>

        //     <div className="col-12 col-md-6 d-flex align-items-center justify-content-center bg-white p-4 p-md-5">
        //         <Card className="shadow-none w-100" style={{ maxWidth: '500px' }}>
        //             <Card.Body>
        //                 <div className="text-center">
        //                     <Image src={logolight} />
        //                     <h3 className="text-pantone mt-4">
        //                         Welcome to Mayave !
        //                     </h3>
        //                     <h4 className="text-dark opacity-75 fs-base">
        //                         Start your journey with us.
        //                     </h4>
        //                 </div>

        //                 <div className="p-2 mt-5">
        //                     {error && <Alert variant="danger">{error}</Alert>}
        //                     <Form onSubmit={validation.handleSubmit}>
        //                         <Form.Group className="mb-3">
        //                             <Form.Label>Username <span className="text-danger">*</span></Form.Label>
        //                             <Form.Control
        //                                 name="userName"
        //                                 placeholder="Enter username"
        //                                 required
        //                                 value={validation.values.userName || ""}
        //                                 onChange={validation.handleChange}
        //                                 onBlur={validation.handleBlur}
        //                                 isInvalid={validation.touched.userName && !!validation.errors.userName}
        //                             />
        //                             <Form.Control.Feedback type="invalid">{validation.errors.userName}</Form.Control.Feedback>
        //                         </Form.Group>

        //                         <Form.Group className="mb-3">
        //                             <Form.Label>Password <span className="text-danger">*</span></Form.Label>
        //                             <div className="position-relative">
        //                                 <Form.Control
        //                                     type={passwordShow ? "text" : "password"}
        //                                     name="password"
        //                                     placeholder="Enter password"
        //                                     required
        //                                     value={validation.values.password || ""}
        //                                     onChange={validation.handleChange}
        //                                     onBlur={validation.handleBlur}
        //                                     isInvalid={validation.touched.password && !!validation.errors.password}
        //                                 />
        //                                 <Button
        //                                     variant="link"
        //                                     className="position-absolute end-0 top-0 text-muted"
        //                                     onClick={() => setPasswordShow(!passwordShow)}
        //                                 >
        //                                     <i className="ri-eye-fill" />
        //                                 </Button>
        //                                 <Form.Control.Feedback type="invalid">{validation.errors.password}</Form.Control.Feedback>
        //                             </div>
        //                         </Form.Group>

        //                         <Form.Group controlId="formRememberMe" className="mb-3">
        //                             <Form.Check type="checkbox" label="Remember me" />
        //                         </Form.Group>

        //                         <Button className="w-100 rounded-2 py-2 bg-pantone" type="submit" disabled={loading}>
        //                             {loading && <Spinner size="sm" />} Sign In
        //                         </Button>
        //                     </Form>
        //                 </div>
        //             </Card.Body>
        //         </Card>
        //     </div>
        // </div>

<ParticlesAuth>
            <>
                {loader && <Loader />}
                <Col xxl="6" lg="6" md="6" className="mx-auto">
                    <Card className="shadow-none">
                        <Card.Body className="p-sm-5 m-lg-4">
                            <div className="text-center">
                                <Image src={logolight} />
                                <h3 className="text-pantone mt-4">
                                    Welcome to Mayave !
                                </h3>
                                <h4 className="text-dark opacity-75 fs-base">
                                    Start your journey with us.
                                </h4>
                            </div>
                            <div className="p-2 mt-5">
                                {error && <Alert variant="danger">{error}</Alert>}
                                <Form onSubmit={validation.handleSubmit}>
                                    <Form.Group className="mb-3" controlId="formUsername">
                                        <Form.Label>Username <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            name="userName"
                                            className="form-control"
                                            placeholder="Enter username"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.userName}
                                            isInvalid={validation.touched.userName && !!validation.errors.userName}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {String(validation.errors.userName)}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formPassword">
                                        <Form.Label>Password <span className="text-danger">*</span></Form.Label>
                                        <div className="position-relative auth-pass-inputgroup mb-3">
                                            <Form.Control
                                                type={passwordShow ? "text" : "password"}
                                                className="form-control pe-5"
                                                placeholder="Enter password"
                                                name="password"
                                                value={validation.values.password}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                isInvalid={validation.touched.password && !!validation.errors.password}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {String(validation.errors.password)}
                                            </Form.Control.Feedback>
                                            <Button
                                                variant="link"
                                                className="position-absolute end-0 top-0 text-decoration-none text-muted"
                                                type="button"
                                                onClick={() => setPasswordShow(!passwordShow)}
                                            >
                                                <i className="ri-eye-fill align-middle"></i>
                                            </Button>
                                        </div>
                                    </Form.Group>
                                    <Form.Group controlId="formRememberMe">
                                        <Form.Check type="checkbox" label="Remember me" id="auth-remember-check" />
                                    </Form.Group>
                                    <div className="mt-4">
                                        <Button
                                            className="btn btn-primary bg-pantone w-100 rounded-2 py-2"
                                            type="submit"
                                            disabled={loading}
                                        >
                                            {loading && <Spinner size="sm" />} {" "}Sign In
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </>
        </ParticlesAuth>

    );
};

export default withRouter(Signin);
